import { render, staticRenderFns } from "./cate02.vue?vue&type=template&id=70a36971"
import script from "./cate02.vue?vue&type=script&lang=js"
export * from "./cate02.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports